import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Card } from "antd";
import { Responsive, WidthProvider } from 'react-grid-layout';
import RouteMap from "components/Common/Maps/RouteMap";
import GraphPanel from "./GraphPanel";

const ResponsiveGridLayout = WidthProvider(Responsive);

const LocationLayout = forwardRef((props, ref) => {
    const { layouts, selectedChart, crossHair=false, enableZoom,
        data, isLoading, isError, error,
    } = props;
    
    const locationFields = ['speed', 'altitude'];
    const chartRefs = useRef(Array.from({ length: locationFields.length }, () => null));
    const containerRefs = useRef(Array.from({ length: locationFields.length }, () => null));
    let chartsData = [];

    useImperativeHandle(ref, () => ({
        resetZoomAll() {
            chartRefs?.current.forEach(ref => {
                const chart = ref;
                if (chart) chart.zoomOut();
            });
        }
    }));

    const routes = data?.data?.map((entry) => [entry?.latitude, entry?.longitude]);
    chartsData = locationFields.map((field) => data?.data.map((entry) => [entry?.timestamp, entry?.[field]]));


    const syncZoom = (min, max, sourceChartIndex) => {
        chartRefs?.current.forEach((ref, index) => {
            if (index !== sourceChartIndex) {
                if (ref) {
                    ref?.xAxis?.[0]?.setExtremes(min, max, true, false, { trigger: 'sync' });
                }
            }
        });
    };

    const syncCrosshairs = (e) => {
        chartRefs?.current.forEach(ref => {
            if (ref) {
                const event = ref?.pointer?.normalize(e);
                event.chartX = event ? e?.offsetX : null;// (Please do not delete this)
                const point = event ? ref?.series[0]?.searchPoint(event, true) : null;
                if (point) {
                    point.onMouseOver();
                    ref?.tooltip?.refresh(point, event);
                    ref?.xAxis?.[0]?.drawCrosshair(event, point);
                }
            }
        });
    };
    
    const clearCrosshairs = () => {
        chartRefs.current.forEach(ref => {
            ref?.tooltip?.hide();
            ref?.xAxis?.[0]?.hideCrosshair();
        });
    };

    return(
        <ResponsiveGridLayout
            layouts={layouts}
            breakpoints={{ lg: 1200, md: 996, sm: 768 }}
            cols={{ lg: 12, md: 12, sm: 12 }}
            rowHeight={30}
            margin={[10, 14]}
            isDraggable={false}
            isResizable={false}
            useCSSTransforms={false}
        >
            <div key="panel1" className="panelStyle">
                <Card             
                    bordered={false}
                    className="locations-card"
                    title={'Route Map'} 
                    style={{minHeight:'715px'}}
                >
                    <RouteMap 
                        routes={routes}
                        isLoading={isLoading} 
                        isError={isError} 
                        dataErrorMsg={error?.message}         
                />
                </Card>
            </div>
            {chartRefs?.current?.map((_, i) => {
                return(
                    <div key={`panel${i+2}`} className="panelStyle">
                        <GraphPanel 
                            title={locationFields[i].toUpperCase()} 
                            plotType={selectedChart}
                            panelData={chartsData[i]}
                            panelSeries={locationFields[i]}
                            isLoading={isLoading} 
                            isError={isError} 
                            dataErrorMsg={error?.message}         
                            enableZoom={enableZoom}
                            syncZoom={syncZoom}
                            crossHair={crossHair}
                            onCursorMove={crossHair ? syncCrosshairs : null}
                            onCursorLeave={crossHair ? clearCrosshairs : null}
                            setChartRef={(chart) => (chartRefs.current[i] = chart)}
                            setContainerRef={(container) => (containerRefs.current[i] = container)}
                            chartIndex={i}
                        />
                    </div>
                )
            })}
        </ResponsiveGridLayout>        
    )
});

export default LocationLayout;